<iframe
    [src]="data.redirect_url | safeUrl"
    mozallowfullscreen="mozallowfullscreen"
    msallowfullscreen="msallowfullscreen"
    oallowfullscreen="oallowfullscreen"
    webkitallowfullscreen="webkitallowfullscreen"
    allowfullscreen="true"
></iframe>
